export default [
  {
    path: window.pathApp + '/contato',
    name: 'contato',
    component: () => import('@/components/Contato'),
    meta: {
      login: false,
      avisoCarrinho: true,
      title: "Contato",
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/routes/contato.js